import { useEffect } from "react"
import { StepProps } from "../../../../components/Stepper"
import { AuthData } from "../../../../types/steps/auth"
import { useRequest } from "../../../../hooks/useRequest"
import { useAuth } from "../../../../hooks/useAuth"
import { applyPendingLocation, getAuthCityId } from "../../../../lib/locationSwitch"
import { userStore } from "../../../../store/userStore"
import { useNavigate } from "react-router-dom"
import Loader from "../../../../components/Loader"
import { openTelegramBot } from "../../../../lib/telegram"
import { clearAuthDraft } from "../../../../lib/authDraft"
import AuthSheetLayout, { AuthSheetButton } from "../../../../features/auth/AuthSheetLayout"
import { AuthCaption } from "../../../../features/auth/AuthShell"

export default function Telegram({ params, goBack }: StepProps<AuthData>) {
    const { phone, registered } = params
    const { requestData } = useRequest()
    const { setUser } = userStore()
    const { checkCode } = useAuth()
    const router = useNavigate()

    const sendTg = async () => {
        const { status } = await requestData({
            type: "POST",
            path: "telegram/status",
            sendData: {
                city_id: getAuthCityId(),
                phone: phone,
            },
        })
        if (status === "success") {
            const user = await checkCode("0000", registered!, phone!)
            clearAuthDraft()
            setUser(user)
            applyPendingLocation()
            router(-1)
        }
    }

    useEffect(() => {
        sendTg()
        const id = setInterval(sendTg, 5000)
        return () => clearInterval(id)
    }, [])

    return (
        <AuthSheetLayout
            title="Telegram"
            onBack={goBack}
            footer={<AuthSheetButton variant="primary" onClick={openTelegramBot}>Открыть Telegram</AuthSheetButton>}>
            <div className="flex flex-col items-center gap-4 py-4">
                <Loader />
                <p
                    className="text-center text-[20px] leading-snug text-white"
                    style={{ fontFamily: "'Tilda Sans', sans-serif", fontWeight: 700, letterSpacing: "-0.01em" }}>
                    Ждём ответ от бота
                </p>
                <AuthCaption className="text-left">
                    Проверьте, что вы авторизованы в Telegram под номером
                    <span className="text-white">{` +7${phone}`}</span>
                </AuthCaption>
            </div>
        </AuthSheetLayout>
    )
}
